import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=0b162289&scoped=true&lang=pug&"
import script from "./Achievements.vue?vue&type=script&lang=ts&"
export * from "./Achievements.vue?vue&type=script&lang=ts&"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=0b162289&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b162289",
  null
  
)

export default component.exports